import axios from 'axios'
import { useState } from 'react'
import authService from '../../../../Components/Login/auth.service'
import '../../../../styles/pages/SubMenuPages/SubMenuTipoDeObservacao/modal-tiposDeobservacoes/modalNovoTipoDeobservacao.css'
//const uuidv4 = require('uuid/v4')

export default function Modal() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  var user = authService.getCurrentUser();
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdObservacaoGrupo: 0,
    IdObservacaoTipo: sessionStorage.IdObservacaoTipoEdit,
    IdEmpresa: user[0].IdEmpresa,
    ogrNumero: 0,
    ogrDescricao: '',
    ogrStatus: 1,
    ogrObservacoes: '',
    ogrCriadoPor: user[0].pesEmail,
    ogrCriadoEm: newDate,
    ogrAlteradoPor: user[0].pesEmail,
    ogrAlteradoEm: newDate,
    ogrCodigoGUID: uuidv4
  })

  function handleInputChange(event) {
    // if (event.target.name === 'ogrStatus') {
    //   if (event.target.checked) {
    //     campos[event.target.name] = 1
    //   } else {
    //     campos[event.target.name] = 0
    //   }
    // } else {
    campos[event.target.name] = event.target.value
    //}
    setCampos(campos)
  }

  function handleFormSubmit(event) {
    event.preventDefault()
    // console.log(campos)
    axios
      .post(process.env.REACT_APP_API_URL + '/api/v1/observacaogrupo', campos)
      .then(response => {
        if (response.status === 200) {
          alert(response.data.message)
          window.location.reload()
        } else {
          alert(response.data.message)
        }
      })
  }
  const [modal, setModal] = useState(false)

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }

  return (
    <>
      <button onClick={toggleModal} className="buttonModalPadrao">
        Novo Grupo
      </button>

      {modal && (
        <div className="overlay">
          <div className="modalPadrao-content">
            <div className="cxTituloPadrao">
              <h1>Novo Grupo De Questões
                <hr className='hrTitleModal' />
              </h1>
              <button className="close-modal" onClick={toggleModal}>
                X
              </button>
            </div>

            <form onSubmit={handleFormSubmit}>
              <div className="linhaTipObs" style={{ width: '100%' }}>
                <tr>
                  <th><label>Ordem</label></th>
                  <th><label>Descrição:</label></th>
                </tr>
                <tr>
                  <td>
                    <input
                      type="number"
                      id="ogrNumero"
                      name="ogrNumero"
                      min={1}
                      required
                      onChange={handleInputChange}>
                    </input>
                  </td>
                  <td style={{ width: 780 }}>
                    <input
                      type="text"
                      id="ogrDescricao"
                      name="ogrDescricao"
                      required
                      onChange={handleInputChange}>
                    </input>
                  </td>
                </tr>
              </div>

              <label>
                Observação:
              </label>
              <textarea
                type="text"
                id="ogrObservacoes"
                name="ogrObservacoes"
                row="none"
                maxLength="500"
                onChange={handleInputChange}
              ></textarea>

              <div className="caixaSalvarPadrao">
                <button type='submit'>
                  Salvar Grupo
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}
